export interface TechItem {
	name: string
	icon: string
}

export const TECH_STACK: TechItem[] = [
	{ name: 'JavaScript', icon: 'JS' },
	{ name: 'TypeScript', icon: 'TS' },
	{ name: 'React', icon: '⚛️' },
	{ name: 'Redux', icon: '🔄' },
	{ name: 'Next.js', icon: '▲' },
	{ name: 'Vue', icon: '💚' },
	{ name: 'Nuxt', icon: 'N' },
	{ name: 'HTML5', icon: 'HTML' },
	{ name: 'CSS3', icon: 'CSS' },
	{ name: 'SCSS/SASS', icon: 'SCSS' },
	{ name: 'Node.js', icon: '🟢' },
	{ name: 'Git', icon: '🔀' },
	{ name: 'Webpack', icon: '📦' },
	{ name: 'Vite', icon: '⚡' },
	{ name: 'Jest', icon: '🧪' },
	{ name: 'React Testing Library', icon: '🔬' },
	{ name: 'Storybook', icon: '📚' },
	{ name: 'Docker', icon: '🐳' },
	{ name: 'CI/CD', icon: '🚀' },
	{ name: 'REST API', icon: '🌐' },
	{ name: 'GraphQL', icon: '📊' },
	{ name: 'WebSocket', icon: '🔌' },
	{ name: 'ESLint', icon: '✅' },
	{ name: 'Prettier', icon: '💅' },
	{ name: 'Accessibility', icon: '♿' },
	{ name: 'Performance', icon: '🚄' },
	{ name: 'Microfrontends', icon: '🧩' },
	{ name: 'Feature-Sliced Design', icon: '🏗️' },
]
